<template>
    <header>
        <a class="logo" href="/"><img src="../assets/images/360Agency.png" alt="The 360 Agency"></a>
    </header>
</template>

<script>
export default {
    name: 'Header'
}
</script>